export { default as mainUIBlockTemplate } from './mainUIBlock.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/main-ui-block/templates/index.ts